































































































































































import { Component, Vue } from 'vue-property-decorator'
import axios from 'axios'
import { DownloadHistoryInfo } from '../../../modules/class/Downloads'
import DownloadLink from '../DownloadLink.vue'
import ErrorFormResponse from '../../../modules/class/ErrorFormResponse'
import PathUtil from '../../../modules/util/PathUtil'
import UidCookie from '../../../modules/util/UidSetCookie'
import { SapLoginInfo, ssoLogin } from '../../../modules/util/SapUtil'

const BOOKMARKS_URL = PathUtil.makePath('/member/s/bookmarks/index.html')

@Component({
  components: {
    DownloadLink
  }
})
export default class MypageTopDownloadHistory extends Vue {
  private readonly vueid = 'vue_mypage_top_download_history'

  // --------------------------------------------------------------------------------------------------------------------
  // data
  private bookmarksUrl = BOOKMARKS_URL

  private resultError: ErrorFormResponse = {}
  private haserror = false
  private downloadhistory: DownloadHistoryInfo[] = []
  private movetodownloadhistory = ''

  private uidcookie = new UidCookie()

  // -------------------------------------------------------------------------------------------------------------------
  // hocks

  private beforeMount() {
    // move to download history tab page
    this.movetodownloadhistory =
      drupalSettings.vueComponent.membershipcontroll.myPage.downloadHistory
  }

  private created() {
    this.clearError()
  }

  private mounted() {
    if (document.getElementById(this.vueid) !== null) {
      this.inittoppage()
    }
  }

  // -------------------------------------------------------------------------------------------------------------------
  // methods

  /**
   * download url clickにて発生したエラーを初期化する
   */
  private clearError() {
    this.resultError = {}
    this.haserror = false
  }

  /**
   * download url clickにて発生したエラーをDownladLinkコンポーネントから受け取る
   */
  private setError(error: ErrorFormResponse) {
    this.resultError = error
    this.haserror = true
  }

  /**
   * init get latest download history
   */
  private async inittoppage() {
    window.gigya.accounts.verifyLogin({
      include: 'preferences',
      callback: this.verifyLoginDownloadResponse
    })
  }

  /**
   * ダウンロード履歴取得コールバック
   */
  private async verifyLoginDownloadResponse(response: {
    errorCode: number
    UID: string
    UIDSignature: string
    signatureTimestamp: string
  }) {
    if (response.errorCode === 0) {
      const info: SapLoginInfo = {
        UID: response.UID,
        UIDSignature: response.UIDSignature,
        signatureTimestamp: response.signatureTimestamp
      }

      // Cookieに３点セットをセット
      this.uidcookie.setUid(info)

      const form = JSON.stringify({
        limit: 10,
        offset: 0
      })
      try {
        const res = await axios.post(
          PathUtil.makePath('/member/api/download_history'),
          form
        )
        if (res.data.total > 0) {
          for (const item of res.data.history) {
            this.downloadhistory.push(new DownloadHistoryInfo(item))
          }
        } else {
          // nothing download history
        }
      } catch (err) {
        if (axios.isAxiosError(err) && err.response?.status === 403) {
          ssoLogin(window.location.href, 'gigya-login-screen')
        }
      }
    } else {
      // ログインしていないときはCookieを消す
      this.uidcookie.unSetUid()
    }
  }

  /**
   * view more click
   */
  private async viewMore() {
    // go to download history page
    window.location.href = this.movetodownloadhistory
  }

  /**
   * ドキュメントタイトルクリック
   */
  private documentTitleClick(index: number) {
    // クリックした要素を取得
    const clickElement: Element | null =
      document.getElementsByClassName('historytitle').item(index) !== null
        ? document.getElementsByClassName('historytitle').item(index)
        : null
    if (clickElement !== null) {
      // 親要素を取得
      const parentElement: HTMLElement | null =
        clickElement.parentElement !== null ? clickElement.parentElement : null
      if (parentElement !== null) {
        // 次の兄弟要素を取得
        const nextElementSibling: Element | null =
          parentElement.nextElementSibling !== null
            ? parentElement.nextElementSibling
            : null
        if (nextElementSibling !== null) {
          // ダウンロードリンク要素を取得
          const downloadLinkElement: HTMLElement | null =
            nextElementSibling.getElementsByTagName('a').item(0) !== null
              ? nextElementSibling.getElementsByTagName('a').item(0)
              : null
          if (downloadLinkElement !== null) {
            // ダウンロードリンクのクリックと同様の処理を行う
            downloadLinkElement.click()
          }
        }
      }
    }
  }
}
